module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/车载2.ad4aac2e.png";